import * as styles from "./CardClass.css";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import { ImageProps } from "~/components/elements/Image";
import DrawnBorder from "~/assets/svgs/DrawnBorder";
import { Media, MediaProps } from "./Media";
import { ComponentPropsWithRef } from "react";
import { ProgressBar, ProgressBarProps } from "./ProgressBar";
import Icon from "../elements/Icon";
import { MarkerPin01, Pin01, Pin02 } from "@untitled-ui/icons-react";
import { Paragraph } from "../elements/Paragraph";

type CardClassProps = {
  schoolName?: string;
  text?: string;
  progress?: ProgressBarProps;
  aspectRatio?: "default" | "shallow"
} & MediaProps & ComponentPropsWithRef<"div">;

export const CardClass = ({ aspectRatio = 'default', media,text,schoolName, progress,children, ...props }: CardClassProps) => {
  return (
    <div className={styles.container} {...props}>
      <WrapperDrawnBorder className={styles.wrapper}>
        <div className={styles.card}>
          <div className={styles.text}>{children}</div>
          <div className={styles.separator}>
            <DrawnBorder />
          </div>
          <div className={styles.imageContainer({aspectRatio: aspectRatio})}>
            {media.image?.src && (
              <Media className={styles.image} media={{ image: {...media.image, width:450} }} />
            )}
          </div>
          <div className={styles.separator}>
            <DrawnBorder />
          </div>
          <div className={styles.textLower}>
            
            {schoolName &&<div className={styles.school}> <Icon size="18px" svg={MarkerPin01} /><Paragraph >{schoolName}</Paragraph></div>}
            {text && <Paragraph size="Lg" className={styles.cardText}>{text}</Paragraph>}
            {progress && <ProgressBar {...progress} className={styles.progress}/>}
          </div>
        </div>
      </WrapperDrawnBorder>
    </div>
  );
};
